import React, { useEffect, useState } from "react";
import BenefitsCard from "./BenefitsCardComponent";
import { Grid, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import '../assets/css/benefits.css'
import useDataStore from "../store/dataStore";

const Benefits = (props) => {

  const data = useDataStore((state) => state.data);
  console.log("data",data);
  const benefitsList = props.benefits.filter(item => data.benefits.benefList.includes(item.key)).map((benefit) => {
    return (
      <Grid item xs={12} sm={6} md={3}>
        <BenefitsCard benefit={benefit} />
      </Grid >
    );
  });

  return (
    <div>
      <div className="benefitsheader">

        {data.benefits.showOurBenifts && (<><h4 className="benefitsHeading">Our Benefits </h4>
        <h3 className="benefitsSubHeading">The MediBuddy Experience </h3></>)
      }
        

      </div>
      <div className="Benefits">
        <Container>
          <Grid
            container
            spacing={4}
            justifyContent="center"
          >
            {benefitsList}
          </Grid>
        </Container>
      </div>
    </div>
  );
}
export default Benefits;
